import { EventTypeMap, Tracker as UITracker } from '@updater/ui-tracker';
import { useQual } from 'hooks/useQual';
import { useCallback, useEffect, useMemo } from 'react';
import { useEnvironment } from 'services/environment';
import { eventTypeMap } from 'services/tracker/eventTypeMap';
import { TrackingCallback, useGrowthbookTracking } from './GrowthbookWrapper';

const appName = 'marketing_sites';

export const GrowthbookExperimentTracker: React.FC = () => {
  const env = useEnvironment();
  const { uuid } = useQual();

  const tracker = useMemo(() => {
    return new UITracker<EventTypeMap>({
      eventTypeMap,
      environment: env.inProduction ? env.name : 'sandbox',
      destinations: {
        eventstream: {
          app: appName,
          url: env.eventStream,
          authorization: env.eventStreamToken,
        },
      },
      channel: appName,
      debug: !env.inProduction,
      appName,
    });
  }, [env.name, env.eventStream, env.eventStreamToken, env.inProduction]);

  useEffect(() => {
    tracker.identify({
      uuid,
      email: '',
      moverId: '',
    });
  }, [tracker, uuid]);

  useEffect(() => () => tracker.destroy(), [tracker]);

  const trackingCallback = useCallback<TrackingCallback>(
    (experiment, result) => {
      tracker.trackUntyped({
        domain: 'marketing_sites',
        object: 'experiment',
        verb: 'sorted',
        details: {
          experiments: {
            [experiment.key]: result.value,
          },
          bucketing_id: result.hashValue,
          anonymous_user_id: uuid,
          experiment_key: experiment.key,
          variation_key: experiment.variations?.[result.variationId],
        },
      });
      tracker.trackUntyped({
        domain: 'marketing_sites',
        object: 'user',
        verb: 'updated',
        details: {
          experiments: {
            [experiment.key]: result.value,
          },
          bucketing_id: result.hashValue,
        },
      });
      tracker.trackUntyped({
        domain: 'marketing_sites',
        object: 'growthbookTrack',
        verb: 'tracked',
        details: {
          event_key: experiment.key,
          result,
          bucketing_id: result.hashValue,
        },
      });
    },
    [tracker, uuid]
  );

  useGrowthbookTracking(trackingCallback);

  return null;
};
